/**
 * Cargar la información de los productos químicos.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 */
export function getEmpresasFil(state) {
    return state.empresas
}

/**
 * Cargar la información de los productos químicos.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 */
export function getChecklist(state) {
    return state.tipoListaChequeo
}